import utils from '../utils'
import api from '../apis'
export default {
    state: {
        siteInfo: {}
    },
    getters: {
        siteInfo(state) {
            return state.siteInfo;
        }
    },
    mutations: {
        setSiteInfo(state, siteInfo) {
            state.siteInfo = siteInfo;
        },
        removeSiteInfo(state) {
            state.siteInfo = {};
        }
    },
    actions: {
        removeSiteInfo({
            commit
        }) {
            commit('removeSiteInfo')
        },
        loadSiteInfo({
            commit
        }, UserID, CompanyID) {
            return api.system.getSiteInfo({
                failTips: false
            }).then(function(json) {
                if (!json.data.isSucc) {
                    return json;
                }
                // console.log(json);
                commit('setSiteInfo', json.data.result);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/siteStore.js